const localization = {
    general: {
        component_barcode: 'Component Barcode Value',
        daily_fluid_milk_quota: 'Quota',
        hauling_plural: 'Hauling Companies',
        hauling_singular: 'Hauling Company',
        hauling_delivery: 'Delivery Hauler',
        full_name: 'Contact Name',
        metered: 'Processor Weight',
        meteredLevel: 'Processor Weight',
        license_number: 'Processor ID',
        monthlyReports: 'Monthly Reports',
        processor_singular: 'Processor',
        processor_plural: 'Processors',
        producer_weight: 'Producer Weight',
        routeNumber: 'Lt Number',
        lt_number: 'LT Number',
        route_number: 'LT Number',
        routeSession: 'Route Session',
        tank: 'Tank',
        trailer: 'Trailer',
        transfer: 'Quota',
        volume: 'Producer Amount',
    },
    navigation: {
        'Base Transfers': 'Quota Transfers',
    },
    lab: {
        scc: 'scc',
        temperature: 'Freezing Point',
        sample_date: 'Date',
    },
    other: {},
};

export default localization;
